/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconAquarius: {
  name: 'aquarius';
  data: string;
} = {
  name: 'aquarius',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M172.933 206.344 43.099 297.989V195.522L211.91 83.901l42.035 81.444L360.169 82.35l43.166 81.388L509.803 84.2l57.251 85.001-1.518 134.761-81.233-93.884-111.588 81.394-41.431-82.84L220.1 286.419l-47.167-80.075zM172.933 438.385 43.099 530.041V427.574L211.91 315.959l42.035 81.433 106.224-82.99 43.166 81.388 106.468-79.543 57.251 85.007-1.518 134.761-81.233-93.884-111.588 81.388-41.431-82.84L220.1 518.471l-47.167-80.086z"/></svg>`,
};
